package org.solyton.solawi.bid.module.context.`data`

import kotlin.String
import org.evoleq.axioms.definition.ReadWrite
import org.evoleq.optics.lens.Lens

/**
 * Autogenerated Lens.
 * Read and manipulate [Context.current]
 */
@ReadWrite
public val current: Lens<Context, String> by lazy {
      Lens(
        get = { whole -> whole.current },
        set = { part -> { whole -> whole.copy(current = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [Context.current]
 */
@ReadWrite
public fun Context.current(`set`: String.() -> String): Context = copy(current = set(current))

/**
 * Autogenerated Lens.
 * Read and manipulate [Context.next]
 */
@ReadWrite
public val next: Lens<Context, String?> by lazy {
      Lens(
        get = { whole -> whole.next },
        set = { part -> { whole -> whole.copy(next = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [Context.next]
 */
@ReadWrite
public fun Context.next(`set`: String?.() -> String?): Context = copy(next = set(next))
